import { WalletPostBody } from '@mkp/shared/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const creditManagementPageActions = createActionGroup({
  source: 'Credit Management Page',
  events: {
    enter: emptyProps(),
    addNewWallet: props<Pick<WalletPostBody, 'name'>>(),
    loadCredits: emptyProps(),
  },
});
